import React, { useState, useEffect } from "react";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import Footer from "../pages/Footer";
import Header from "../pages/Header";
import "../../styles/AuthStyle.css";
import TextBox from "../pages/TextBox";
import { Link, useNavigate } from "react-router-dom";
import String from "../../lang/String";
import { images } from "../../common/Images";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MutatingDots } from "react-loader-spinner";
import EncryptDecrypt from "../../common/Crypto";
import store from "../../redux/Store";

function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, inputChange] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setvisible] = useState(false);
  const [phone_no, setPhone_no] = useState("");
  const [referral, setReferral] = useState("");
  const [BtnLoad, setBtnLoad] = useState(false);
  const [emailError, setemailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [passError, setpassError] = useState("");
  const [firstError, setfirstError] = useState("");
  const [lastError, setlastError] = useState("");
  const [checked, setchecked] = useState(false);
  const [loader, setloader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let isAuth = localStorage.getItem("customerId");
    if (isAuth && isAuth !== null) {
      navigate("/");
    }
  }, []);

  const prefixImg = (src) => {
    return (
      <div
        className="pre-icon"
        style={{ borderRight: `2px solid ${Colors.Base_color}` }}
      >
        {/* <i class="fa-solid fa-envelope"></i> */}
        {/* {src == 1 ?  */}
        <i class={`fa-${(src != 'phone' && src != 'people-group') ? 'regular' : 'solid'} fa-${src} d-flex justify-content-center align-items-center`} style={{height: '25px', width: '25px', color: Colors.Base_color}}></i> 
        {/* <img
          src={src}
          className=""
          style={{ objectFit: "contain" }}
          height={25}
          width={25}
        />
         } */}
        
      </div>
    );
  };
  const SuffixImg = (value, type = 1) => {
    if (type === 1) {
      return (
        <div
          role="button"
          className="sufficIm"
          onClick={() => setvisible(!visible)}
        >
          <i
            class={visible ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}
          ></i>
          {/* <img src={value} className='sufficImg' height={18} width={25} /> */}
        </div>
      );
    } else {
      return (
        <div
          role="button"
          className="sufficIm Pointer_eye"
          onClick={() => setvisible(!visible)}
        >
          <i style={{ color: "red" }} class="fa-regular fa-eye"></i>
        </div>
      );
    }
  };

  const loginValidation = () => {
    let isValid = true;
    if (firstName === "") {
      isValid = false;
      setfirstError("Enter your first name");
    } else {
      // isValid = true;
      setfirstError("");
    }

    if (lastName === "") {
      isValid = false;
      setlastError("Enter your last name");
    } else {
      // isValid = true;
      setlastError("");
    }

    if (email == "") {
      console.log("emal")
      isValid = false;
      setemailError("Enter your email");
    } else {
      // console.log("emal else")
      setemailError("");
      // isValid = true;
    }
    if (email != "") {
      let lastAtPos = email.lastIndexOf("@");
      let lastDotPos = email.lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          email.indexOf("@@") == -1 &&
          lastDotPos > 2
        )
      ) {
        isValid = false;
        setemailError("Enter valid Email");
        // console.log("email val")
      }
    }else{
      // isValid = true;
      // setemailError("");
      // console.log("email val else")
    }

    if (phone_no === "") {
      isValid = false;
      setPhoneError("Phone Number is required");
    } else {
      // isValid = true;
      setPhoneError("");
    }

    if (
      (phone_no && phone_no.length > 10) ||
      (phone_no && phone_no.length < 10)
    ) {
      isValid = false;
      setPhoneError("Enter valid Phone number");
    }else{
      // isValid = true;
      // setPhoneError("");
    }

    // if (password === "") {
    //   isValid = false;
    //   setpassError("Password Required");
    // } else {
    //   isValid = true;
    //   setpassError("");
    // }

    
    // console.log(isValid)
    return isValid;
  };
console.log(emailError)
  const loginFun = async (e) => {
    e.preventDefault();
    if (loginValidation()) {
      setPhoneError("");
      setemailError("");
      setPassword("");
      setfirstError("");
      setlastError("");
      if (!checked) {
        toast.error("You Must agree Terms & condition", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setBtnLoad(true);
        const signUp = {
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone_number: phone_no,
          referral_code: referral.length > 0 ? referral : "",
        };

        ApiCall("auth/register", signUp)
          .then((data) => {
            // console.log("response -->", data);
            // setloader(false);
            if (data.message == "Registered Successfully" || data.message == "Success.") {
              store.dispatch({ type: "signup", payload: data.result });
              localStorage.setItem("first_name", data.result.first_name);
              let loginData =  {
                id: data.result.id,
                first_name :  data.result.first_name,
                last_name:  data.result.last_name,
                email:  data.result.email,
                phone_number: data.result.phone_number,
                avatar: data.result.avatar,
                userType: 0 // Normal user = 0, Guest user = 1
              };
              store.dispatch({ type: "addData", payload: loginData });
              toast.success("Register successfully", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
              // console.log("string -->",data.result.id);
              setTimeout(async function () {
                let cus_id = data.result.id;
                let type = "encrypt";
                let format = "text";

                await EncryptDecrypt(cus_id, type, format, (callback) => {
                  localStorage.setItem("customerId", callback);
                });

                await EncryptDecrypt(
                  data.result.access_token,
                  type,
                  format,
                  (callback) => {
                    localStorage.setItem("access_token", callback);
                  }
                );
              }, 3000);
              setTimeout(() => {
                navigate("/");
              }, 2000);
            } else {
              setBtnLoad(false)
              // console.log("data", data);
              toast.error(data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          })
          .catch((err) => console.log(err));
      }
      // setBtnLoad(false);
      // setloader(true);
    }
    // }
  };

  return loader ? (
    <div className="d-flex align-items-center justify-content-center ban-box">
      <MutatingDots
        height="100"
        width="100"
        color={Colors.Base_color}
        secondaryColor={Colors.Base_color}
        radius="12.5"
        ariaLabel="mutating-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  ) : (
    <>
      <Header make={true} />
      <div
        className="signup-wrapper d-flex justify-content-center align-items-center flex-column padding-sm-1 padding-md-3 padding-lg-5"
        style={{ backgroundColor: Colors.bg_color }}
      >
        <div
          className="form-box d-flex justify-content-center align-items-center flex-column white-box-signup"
          style={{ backgroundColor: Colors.white_color }}
        >
          <p className="login-hd">Sign Up</p>
          <span
            className=""
            style={{ color: "gray", fontFamily: "AvenirLTStdMedium" }}
          >
            Create an account & Get more features !
          </span>
          <div className="inner-form">
          <div className="field-box mt-3 d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg('user')}
                place={"First Name"}
                change={setFirstName}
                input_value={firstName}
                name={"first_name"}
              />
              <span
                className="err-txt"
              >
                {firstError ? firstError : " "}
              </span>
            </div>
            <div className="field-box d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg('user')}
                place={"Last Name"}
                change={setLastName}
                input_value={lastName}
                name={"last_name"}
              />
              <span
                className="err-txt"
              >
                {lastError ? lastError : " "}
              </span>
            </div>
            <div className="field-box d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg('envelope')}
                place={"Email"}
                change={inputChange}
                input_value={email}
                name={"email"}
              />
              <span
                className="err-txt"
              >
                {emailError ? emailError : " "}
              </span>
            </div>
            <div className="field-box d-flex mb-4 flex-column">
              <TextBox
                type={"number"}
                prefix={prefixImg('phone')}
                place={"Phone Number"}
                change={setPhone_no}
                input_value={phone_no}
                name={"ph_number"}
              />
              <span
                className="err-txt"
              >
                {phoneError ? phoneError : " "}
              </span>
            </div>
            {/* <div className="field-box mb-4 d-flex flex-column">
              <TextBox
                type={visible ? "text" : "password"}
                prefix={prefixImg(images.password)}
                place={"Password"}
                change={setPassword}
                input_value={password}
                name={"password"}
                suffix={SuffixImg()}
              />
              <span
                style={{
                  color: "red",
                  height: "5px",
                  alignSelf: "end",
                  marginTop: "-5px",
                }}
              >
                {passError ? passError : " "}
              </span>
            </div> */}
            <div
              className="field-box m-3"
              // style={{ backgroundColor: "#FCC1D1" }}
            >
              <TextBox
                type={"text"}
                prefix={prefixImg('people-group')}
                place={"Referral ID"}
                change={setReferral}
                input_value={referral}
                name={"referral"}
                // bg_color="#FCC1D1"
              />
            </div>
            <div className="d-flex flex-row terms-box justify-content-center">
              {checked ? (
                <i
                  onClick={() => setchecked(!checked)}
                  style={{ color: Colors.Base_color }}
                  className="fa-regular fa-square-check check-box-i mt-1"
                ></i>
              ) : (
                <i
                  style={{ color: Colors.Base_color }}
                  onClick={() => setchecked(!checked)}
                  className="fa-regular fa-square check-box-i mt-1"
                ></i>
              )}
              <div className="d-flex flex-column mx-3 terms-text">
                <span style={{ color: "#126a38" }}>
                  {" "}
                  By Continuing, You agree to our
                </span>
                <p style={{ color: Colors.Base_color }}>
                  Terms & conditions{" "}
                  <span style={{ color: "#126a38" }}>and</span> Privacy Policy
                </p>
              </div>
            </div>
          </div>
          {!BtnLoad ? (
            <button
              className="btn text-center px-5"
              style={{
                backgroundColor: Colors.Base_color,
                fontSize: "22px",
                color: Colors.white_color,
              }}
              onClick={loginFun}
            >
              Create Account
            </button>
          ) : (
            <button
              className="btn text-center px-5"
              style={{
                backgroundColor: Colors.Base_color,
                fontSize: "22px",
                color: Colors.white_color,
                cursor: "wait",
              }}
              // onClick={loginFun}
            >
              Loading...
            </button>
          )}

          <div
            className="mt-3 mb-0 last-box-signup"
            style={{ fontFamily: "AvenirLTStdMedium", color: "gray" }}
          >
            Already have an account?{" "}
            <Link
              to={`/login`}
              style={{ textDecoration: "none", color: Colors.Base_color }}
            >
              Login
            </Link>
          </div>
        </div>

        <ToastContainer />
      </div>
      <Footer />
    </>
  );
}

export default Register;
